import {type VariantProps} from 'class-variance-authority';
import * as React from 'react';

import {cn} from '@/utils/ui';

import {badgeVariants} from './badge-variants';

const iconSizeClasses: Record<string, string> = {
  default: 'size-4',
  small: 'size-4',
  medium: 'size-6',
  large: 'size-8',
};

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {
  leadingIcon?: React.ReactNode;
  trailingIcon?: React.ReactNode;
}

function Badge({
  className,
  variant,
  color,
  size,
  leadingIcon,
  trailingIcon,
  children,
  ...props
}: BadgeProps) {
  const iconClass = iconSizeClasses[size ?? 'default'];
  return (
    <div
      className={cn(badgeVariants({variant, color, size}), className)}
      {...props}
    >
      {leadingIcon && (
        <span className={cn('flex shrink-0 items-center', iconClass)}>
          {leadingIcon}
        </span>
      )}
      {children}
      {trailingIcon && (
        <span className={cn('flex shrink-0 items-center', iconClass)}>
          {trailingIcon}
        </span>
      )}
    </div>
  );
}

export {Badge};
